module.exports = __webpack_public_path__ + "static/PermanentMarker-Regular-c863f8028c2505f92540e0ba7c379002.ttf";